<template>
  <div class="admission-manager">
    <!-- 页面标题 -->
    <div class="page-header">
      <i class="el-icon-s-home page-header__icon"></i>
      <span class="page-header__title">入院办理</span>
    </div>

    <!-- 功能入口卡片 -->
    <div class="card-grid">
      <div
        class="func-card"
        v-for="(item, index) in infoList"
        :key="index"
        @click="handleClick(item.uid)"
      >
        <div class="func-card__icon-wrap" :style="{ background: item.color }">
          <i :class="item.icon" class="func-card__icon"></i>
        </div>
        <div class="func-card__body">
          <div class="func-card__title">{{ item.title }}</div>
          <div class="func-card__desc">{{ item.text }}</div>
        </div>
        <i class="el-icon-arrow-right func-card__arrow"></i>
      </div>
    </div>

    <!-- 入院流程 -->
    <div class="process-section">
      <div class="process-section__header">
        <span class="process-section__line"></span>
        <span class="process-section__label">入院办理流程</span>
        <span class="process-section__line"></span>
      </div>
      <el-steps :active="3" align-center class="admission-steps">
        <el-step title="基本信息录入" icon="el-icon-user">
          <template #description>
            <span class="step-desc">填写老人基本信息及身体状况</span>
          </template>
        </el-step>
        <el-step title="收费项目选择" icon="el-icon-s-order">
          <template #description>
            <span class="step-desc">选择周期及非周期收费项目</span>
          </template>
        </el-step>
        <el-step title="缴费信息录入" icon="el-icon-wallet">
          <template #description>
            <span class="step-desc">录入缴费方式及金额信息</span>
          </template>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";
export default {
  name: "AdmissionManager",
  data() {
    return {
      infoList: []
    };
  },
  methods: {
    handleClick(uid) {
      const routeMap = {
        1: { path: "/AdmissionCancel",    title: "取消预约" },
        2: { path: "/AdmissionConsult",   title: "入院咨询" },
        3: { path: "/AdmissionPg",        title: "评估记录" },
        4: { path: "/AdmissionOlderList", title: "入院办理" }
      };
      const target = routeMap[uid];
      if (target) {
        bus.$emit("homePage", { type: "jump", ...target });
      }
    },
    getPageData() {
      this.infoList = [
        {
          uid: 2,
          icon: "el-icon-edit-outline",
          color: "linear-gradient(135deg, #36cfc9, #1890ff)",
          title: "入院咨询",
          text: "对有意向入住的老人进行登记"
        },
        {
          uid: 3,
          icon: "el-icon-document-checked",
          color: "linear-gradient(135deg, #ffa940, #ff7a45)",
          title: "评估记录",
          text: "对老人自理状态进行评估"
        },
        {
          uid: 1,
          icon: "el-icon-circle-close",
          color: "linear-gradient(135deg, #ff85c2, #f759ab)",
          title: "取消预约",
          text: "对老人预约的床位取消"
        },
        {
          uid: 4,
          icon: "el-icon-s-custom",
          color: "linear-gradient(135deg, #73d13d, #52c41a)",
          title: "入院办理",
          text: "针对老人基本信息身体情况进行填写"
        }
      ];
    }
  },
  created() {
    this.getPageData();
  }
};
</script>

<style scoped lang="scss">
.admission-manager {
  background: #f5f7fa;
  min-height: 100%;
  padding: 24px;
  box-sizing: border-box;
}

/* 页面标题 */
.page-header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
  padding: 16px 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

  &__icon {
    font-size: 20px;
    color: #409eff;
    margin-right: 10px;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
  }
}

/* 功能卡片网格 */
.card-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 32px;
}

.func-card {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 10px;
  padding: 20px 18px;
  cursor: pointer;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #ebeef5;
  transition: all 0.25s ease;

  &:hover {
    box-shadow: 0 4px 16px rgba(64, 158, 255, 0.18);
    border-color: #409eff;
    transform: translateY(-2px);

    .func-card__arrow {
      color: #409eff;
      transform: translateX(3px);
    }
  }

  &__icon-wrap {
    width: 52px;
    height: 52px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 14px;
  }

  &__icon {
    font-size: 26px;
    color: #fff;
  }

  &__body {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 15px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 5px;
  }

  &__desc {
    font-size: 12px;
    color: #909399;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__arrow {
    font-size: 14px;
    color: #c0c4cc;
    flex-shrink: 0;
    margin-left: 8px;
    transition: all 0.25s ease;
  }
}

/* 流程区域 */
.process-section {
  background: #fff;
  border-radius: 10px;
  padding: 28px 40px 32px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
  border: 1px solid #ebeef5;

  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 32px;
  }

  &__label {
    font-size: 15px;
    font-weight: 600;
    color: #606266;
    padding: 0 16px;
    white-space: nowrap;
  }

  &__line {
    flex: 1;
    height: 1px;
    background: linear-gradient(to right, transparent, #dcdfe6);

    &:last-child {
      background: linear-gradient(to left, transparent, #dcdfe6);
    }
  }
}

/* el-steps 定制 */
.admission-steps {
  ::v-deep .el-step__head.is-finish {
    color: #409eff;
    border-color: #409eff;
  }

  ::v-deep .el-step__title.is-finish {
    color: #409eff;
    font-weight: 600;
  }

  ::v-deep .el-step__icon {
    width: 48px;
    height: 48px;
    font-size: 22px;
  }

  ::v-deep .el-step__icon-inner {
    font-size: 22px;
  }

  ::v-deep .el-step__line {
    top: 23px;
  }
}

.step-desc {
  font-size: 12px;
  color: #909399;
  line-height: 1.6;
}
</style>
